// floatingBounds — 떠 있는 녹음 알약(FloatingRecorder)의 위치 고정 계산(순수 함수 · 화면 접근 없음).
//
// 모바일은 <html> 에 zoom 이 걸린다(MobileScale). 그러면 left/top 스타일 px 은 zoom 배로 그려지고
// getBoundingClientRect·innerWidth/innerHeight 는 화면 px 이다 — 화면 px 를 그대로 한계로 쓰면
// 알약이 zoom 배만큼 아래로 밀려 하단 탭바와 겹치고 화면 밖으로 잘린다.
// 그래서 전부 스타일 px(화면 px ÷ scale)로 바꿔 계산하고, 하단 탭바가 있으면 그 위끝을 아래 한계로 쓴다.

// rect 좌표계 ÷ 스타일 px. <html> zoom 이 rect 에 반영되는 브라우저에서 ≈ zoom, jsdom 은 1.
// 같은 축이면 폭·높이 어느 쪽을 넣어도 된다(FloatingRecorder 는 고정 높이 36 을 넣는다).
export function scaleOf(rectWidth, offsetWidth) {
  const scale = offsetWidth > 0 && rectWidth > 0 ? rectWidth / offsetWidth : 1;
  if (!Number.isFinite(scale) || scale < 0.25 || scale > 4) return 1;
  return scale;
}

// 알약이 머물 수 있는 영역(스타일 px). navTop = 하단 탭바 rect.top(화면 px) — 없으면 null.
export function boundsOf({ innerWidth, innerHeight, scale, navTop }) {
  const bottom = navTop != null && navTop > 0 && navTop < innerHeight ? navTop : innerHeight;
  return {
    width: innerWidth / scale,
    height: bottom / scale,
  };
}

export function clampToBounds(x, y, w, h, bounds, margin) {
  const maxX = Math.max(margin, bounds.width - w - margin);
  const maxY = Math.max(margin, bounds.height - h - margin);
  return {
    x: Math.min(Math.max(margin, x), maxX),
    y: Math.min(Math.max(margin, y), maxY),
  };
}

// 저장값이 없을 때의 기본 자리 — 영역 오른쪽 아래에서 gap 만큼 안쪽.
export function defaultPos(w, h, bounds, gap) {
  return {
    x: bounds.width - w - gap,
    y: bounds.height - h - gap,
  };
}
